/* tslint:disable */
/* eslint-disable */
/**
 * Actors API
 * API for managing actors, including legal and physical persons.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PersonDto } from './PersonDto';
import {
    PersonDtoFromJSON,
    PersonDtoFromJSONTyped,
    PersonDtoToJSON,
    PersonDtoToJSONTyped,
} from './PersonDto';
import type { AssureHeaderDto } from './AssureHeaderDto';
import {
    AssureHeaderDtoFromJSON,
    AssureHeaderDtoFromJSONTyped,
    AssureHeaderDtoToJSON,
    AssureHeaderDtoToJSONTyped,
} from './AssureHeaderDto';

/**
 * 
 * @export
 * @interface GetAssureDetailsResponse
 */
export interface GetAssureDetailsResponse {
    /**
     * 
     * @type {AssureHeaderDto}
     * @memberof GetAssureDetailsResponse
     */
    header: AssureHeaderDto;
    /**
     * 
     * @type {PersonDto}
     * @memberof GetAssureDetailsResponse
     */
    details: PersonDto;
}

/**
 * Check if a given object implements the GetAssureDetailsResponse interface.
 */
export function instanceOfGetAssureDetailsResponse(value: object): value is GetAssureDetailsResponse {
    if (!('header' in value) || value['header'] === undefined) return false;
    if (!('details' in value) || value['details'] === undefined) return false;
    return true;
}

export function GetAssureDetailsResponseFromJSON(json: any): GetAssureDetailsResponse {
    return GetAssureDetailsResponseFromJSONTyped(json, false);
}

export function GetAssureDetailsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAssureDetailsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'header': AssureHeaderDtoFromJSON(json['header']),
        'details': PersonDtoFromJSON(json['details']),
    };
}

export function GetAssureDetailsResponseToJSON(json: any): GetAssureDetailsResponse {
    return GetAssureDetailsResponseToJSONTyped(json, false);
}

export function GetAssureDetailsResponseToJSONTyped(value?: GetAssureDetailsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'header': AssureHeaderDtoToJSON(value['header']),
        'details': PersonDtoToJSON(value['details']),
    };
}

